import { useTableURLParams } from "src/hooks/useTableURLParams.ts";
import { AlertValidationDecision } from "src/types/alert";

type AlertsTableParamsType = {
  assignedTo: string;
  ruleIds: string[];
  onlyUserAlerts: boolean;
  decisions: AlertValidationDecision[];
  caseTypeCodes: string[];
};

export const useAlertsTableURLParams = () => {
  const params: AlertsTableParamsType = {
    assignedTo: "",
    ruleIds: [],
    onlyUserAlerts: false,
    decisions: [],
    caseTypeCodes: [],
  };

  const converters = {
    assignedTo: (value) => value,
    ruleIds: (value) => (value ? value.split(",") : []),
    onlyUserAlerts: (value) => value === "true",
    decisions: (value) => (value ? value.split(",") : []),
    caseTypeCodes: (value) => (value ? value.split(",") : []),
  };

  return useTableURLParams(params, converters);
};
